import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { EmpresaResponseDTO } from '../types/company';
import { authService } from '../services/authService';

const CompanySelectPage: React.FC = () => {
  const navigate = useNavigate();
  const [companies, setCompanies] = useState<EmpresaResponseDTO[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [search, setSearch] = useState<string>('');

  useEffect(() => {
    const loadCompanies = async () => {
      try {
        setLoading(true);
        // Backend geralmente não usa acentos em paths; usar "disponiveis"
        const response = await api.get<EmpresaResponseDTO[]>('v1/auth/empresas-disponiveis', {
          headers: { 'Accept': 'application/json' }
        });
        setCompanies(response.data);
      } catch (err: any) {
        setError('Erro ao carregar empresas.');
      } finally {
        setLoading(false);
      }
    };
    loadCompanies();
  }, []);

  const handleSelect = (company: EmpresaResponseDTO) => {
    authService.setCompany(company.id, company.nomeFantasia);
    navigate('/dashboard', { replace: true });
  };

  const filtered = companies.filter(c =>
    c.nomeFantasia.toLowerCase().includes(search.toLowerCase()) ||
    c.razaoSocial.toLowerCase().includes(search.toLowerCase()) ||
    c.cnpj.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-3xl bg-white rounded-lg shadow-lg p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Selecionar Empresa</h1>
        <p className="text-sm text-gray-600 mb-4">Escolha a empresa para filtrar todas as requisições.</p>

        <div className="mb-4">
          <input
            type="text"
            placeholder="Buscar por nome, razão social ou CNPJ"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-red-500"
          />
        </div>

        {loading && <div className="text-gray-700">Carregando empresas...</div>}
        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded-md mb-3">{error}</div>
        )}

        {!loading && !error && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {filtered.map((company) => (
              <div key={company.id} className="border rounded-md p-4 flex flex-col">
                <div className="font-semibold text-gray-900">{company.nomeFantasia}</div>
                <div className="text-sm text-gray-600">{company.razaoSocial}</div>
                <div className="text-sm text-gray-500 mt-1">CNPJ: {company.cnpj}</div>
                <button
                  onClick={() => handleSelect(company)}
                  className="mt-3 inline-flex items-center justify-center px-3 py-2 bg-red-600 hover:bg-red-700 text-white text-sm rounded-md"
                >
                  Selecionar
                </button>
              </div>
            ))}
            {filtered.length === 0 && (
              <div className="col-span-full text-gray-600">Nenhuma empresa encontrada.</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanySelectPage;